import React from "react";
import { ScanLine, ClipboardCheck, LineChart } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const FEATURE_META = [
  { icon: ScanLine, key: "f1", testid: "feature-escanea" },
  { icon: ClipboardCheck, key: "f2", testid: "feature-checklists" },
  { icon: LineChart, key: "f3", testid: "feature-analiza" },
];

export default function AtlasFeatures() {
  const { t } = useI18n();
  return (
    <section
      id="soluciones"
      data-testid="atlas-features"
      className="bg-slate-50/70 border-y border-slate-100 py-14 lg:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {FEATURE_META.map(({ icon: Icon, key, testid }) => (
            <div
              key={testid}
              data-testid={testid}
              className="flex flex-col items-center text-center group"
            >
              <div className="h-16 w-16 rounded-full border-2 border-slate-200 bg-white shadow-sm flex items-center justify-center mb-5 group-hover:border-[#6B46C1]/50 transition-colors">
                <Icon
                  className="text-slate-700 group-hover:text-[#6B46C1] transition-colors"
                  size={28}
                  strokeWidth={1.75}
                />
              </div>
              <h3 className="font-display text-xl lg:text-[22px] font-extrabold text-slate-900">
                {t(`features.${key}.title`)}
              </h3>
              <p className="mt-2 text-slate-500 text-base">{t(`features.${key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
